import { QueryClient } from "@tanstack/react-query";
import { apiRequest } from "@/lib/api";

// Create a client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

type QueryFnOptions = {
  on401?: "throw" | "returnNull";
};

// Get function for react-query
export function getQueryFn(options: QueryFnOptions = {}) {
  return async ({ queryKey }: { queryKey: readonly unknown[] }) => {
    try {
      const endpoint = queryKey[0] as string;
      // Use the unified apiRequest
      const data = await apiRequest("GET", endpoint, undefined, { credentials: "include" });
      return data;
    } catch (error: any) {
      if (error.message === "Unauthorized" && options.on401 === "returnNull") {
        return null;
      }
      console.error("Query function error:", error);
      throw error;
    }
  };
}